import Swiper from "swiper";
import { FreeMode, Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-hb2b]",
  year: "[data-hb2b-year]",
};

const initSwiper = (container, years) => {
  const swiper = new Swiper(container.querySelector(".swiper"), {
    slidesPerView: "auto",
    spaceBetween: 24,

    breakpoints: {
      1024: {
        slidesPerView: 1,
        speed: 0,
      },
    },

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },

    on: {
      realIndexChange: ({ realIndex }) => {
        years.forEach((year, index) => year.classList[realIndex === index ? "add" : "remove"]("active"));
      },
      init: ({ realIndex }) =>
        years.forEach((year, index) => year.classList[realIndex === index ? "add" : "remove"]("active")),
    },
  });

  years.forEach((year, index) => year.addEventListener("click", () => swiper.slideTo(index)));
};

const initBlock = (block) => {
  const years = block.querySelectorAll(selectors.year);

  Swiper.use([Navigation, Pagination, FreeMode]);

  initSwiper(block, years);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
